
  export default {
    name: "blog",
    async asyncData({ req, store, route,app, error }) {
      let host = "";
      if (process.server) {
        host = req.headers.host + route.fullPath;
      } else {
        host = location.host + route.fullPath;
      }
      
      let articles = await app.$hyperBlog.getArticles('category',route.params.category,12);
      let metadata = await app.$hyperBlog.getCategories();
      // The category list is aggregated from the live articles, so a value that
      // is not in it is a category that does not exist. Rendering it empty with
      // index,follow is a soft 404 (#23545). A category that exists always has
      // at least one article, so this never hides a real page.
      // Fails open: an empty list means the categories call itself failed, and a
      // 404 on every category page is a far worse outcome than a thin one.
      const known = ((metadata || {}).categories) || [];
      if (known.length && !known.includes(route.params.category)) {
        return error({ statusCode: 404, message: 'Δεν βρέθηκε η κατηγορία' });
      }
      return { articles,metadata };
    },
    head(){
      return {
        title: `Blog - ${this.$store.getters.store.eshop.name}`,
        script:[{
          hid: "ldBreadcrumbBlog",
          type: "application/ld+json",
          json: this.$hyperSeo.schemas(
            "breadcrumb",
            [{name:'Αρχική',url:'/'},{name:"Blog",url:"blog"},{name:this.$route.params.category,url:this.$route.fullPath}]
          ),
        }],
        meta:[{
          hid: "robots",
          name: "robots",
          content:"index,follow",
        }]
      }
    },
    data() {
      return {
        articles: [],
        article: {},
        search: "",
        limit: 12,
        key: "q",
        total:0,
        categories:[],
        metadata:{}
      };
    },
    methods: {
    async getArticles(_) {
      this.articles = await this.$hyperBlog.getArticles(_.key, _.search, 16);
    },
  },
  };
  